import React from 'react';

const styles = {
    label: "block text-md md:text-lg text-gray-700 font-proximanova",
    sublabel: "block text-md md:text-md text-gray-700 font-proximanova",
    input: "p-2 border border-gray-300 rounded flex-grow",
    button: "ml-2 bg-red text-white px-2 py-1 rounded",
    addLinkButton: "mt-2 text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full",
    select: "p-2 border border-gray-300 rounded mr-2",
    container: "mt-6 flex flex-col",
    sectionHeader: "text-lg md:text-xl 2xl:text-2xl font-semibold",
    sectionSubHeader: "block text-lg md:text-xl 2xl:text-2xl font-medium text-gray-700",
    flexContainer: "flex flex-col mt-2",
    pricingInput: "w-full mt-2 p-2 border border-gray-300",
    flexRow: "flex items-center",
};


const SecondaryDetails = ({
    newProduct,
    setNewProduct,
    handleFreeTrialChange,
    handleFreeVersionChange,
    handlePricingUrlChange
}) => {
    return (
        <div>
            <div className="mt-[16px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>
                    Social Media</label>
                <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                    Please provide the links to your social media profiles, if applicable
                </label>

                <div className="mt-[8px] grid grid-cols-1 gap-[8px]">
                    {["Facebook", "Instagram", "X", "Linkedin"].map((platform) => (
                        <div key={platform} className="flex flex-col">
                            <label className="font-proximanova font-[400] text-[18px] text-[#404040]">{platform}</label>
                            <input
                                type="text"
                                value={newProduct[platform] || ''} // Get the value from newProduct[platform]
                                onChange={(e) => {
                                    setNewProduct(prev => ({
                                        ...prev,
                                        [platform]: e.target.value // Update the platform field in newProduct
                                    }));
                                }}
                                placeholder={`Please enter your ${platform} link`}
                                className="w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none"
                            />
                        </div>
                    ))}
                </div>

                <div className="mt-[16px]">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Pricing URL</label>
                    <input
                        className="w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none"
                        placeholder="If you have a page with pricing details, please enter the URL here"
                        value={newProduct.pricingUrl}
                        onChange={(e) => handlePricingUrlChange(e.target.value)}
                    />
                </div>

                <div className="mt-[16px]">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Does your product offer a free trial?</label>
                    <select
                        className="w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none"
                        value={newProduct.freeTrial}
                        onChange={(e) => handleFreeTrialChange(e.target.value)}
                    >
                        <option value="">Select an option</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="mt-[16px]">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Does your product have a free version?</label>
                    <select
                        className="w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none"
                        value={newProduct.freeVersion}
                        onChange={(e) => handleFreeVersionChange(e.target.value)}
                    >
                        <option value="">Select an option</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>
            </div>
        </div >
    );
};

export default SecondaryDetails;
